import React from 'react'
import InstitutionUser from './institution-user'
import UserMembership from './user-membership'

const Spacer = () => <div style={{ paddingTop: '20px' }} />

const MembershipStatus = ({ userId }) => (
  <div>
    <InstitutionUser userId={userId} />
    <Spacer />
    <UserMembership userId={userId} />
  </div>
)

export default MembershipStatus
